const gql = (template: TemplateStringsArray) => template.join('');

export const issueListQuery = gql`
  query IssueListQuery(
    $jql: String
    $first: Int
    $last: Int
    $filterId: Int
    $after: String
    $before: String
    $isMaxResultsLimitEnabled: Boolean!
  ) {
    issues(
      first: $first
      last: $last
      jql: $jql
      filterId: $filterId
      after: $after
      before: $before
      isMaxResultsLimitEnabled: $isMaxResultsLimitEnabled
    ) {
      nodes {
        ...GetIssueDetails
      }
      ...GetTotalCountFragment
      ...GetPaginationInfo
    }
  }

  fragment GetIssueDetails on Issue {
    ...GetIdFragment
    ...GetIssueIdFragment
    ...GetIssueKeyFragment
    ...GetAssigneeFragment
    ...GetIssueTypeFragment
    ...GetSummaryFragment
    ...GetStatusFragment
  }

  fragment GetIdFragment on Issue {
    id
  }

  fragment GetIssueIdFragment on Issue {
    issueId
  }

  fragment GetIssueKeyFragment on Issue {
    issuekey {
      stringValue
    }
  }

  fragment GetAssigneeFragment on Issue {
    assignee {
      userValue {
        accountId
        avatarUrl
        displayName
        emailAddress
      }
    }
  }

  fragment GetIssueTypeFragment on Issue {
    issuetype {
      iconUrl
      name
    }
  }

  fragment GetSummaryFragment on Issue {
    summary {
      textValue
    }
  }

  fragment GetStatusFragment on Issue {
    status {
      name
      statusId
      statusCategoryId
    }
  }

  fragment GetTotalCountFragment on GQLIssueConnection {
    totalCount
  }

  fragment GetPaginationInfo on GQLIssueConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
`;
